// Module
var code = "<div data-moduleicon=\"fpd-icon-layouts\" data-defaulttext=\"Layouts\" data-title=\"modules.layouts\"> <div class=\"fpd-scroll-area\"> <div class=\"fpd-grid fpd-grid-contain fpd-padding\"></div> </div> </div>";
// Exports
module.exports = code;